import { useState } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from './AuthContext';

export const AdminLogin = () => {
  const { admin, login } = useAuth();
  const navigate = useNavigate();
  const { lang } = useParams();
  const activeLang = lang || 'en';
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (admin === undefined) return <div className="min-h-screen bg-page" />;
  if (admin) return <Navigate to={`/${activeLang}/admin/blog`} replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login('waela@thescrappymarketer.com', password);
      navigate(`/${activeLang}/admin/blog`);
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen bg-page flex items-center justify-center px-5 md:px-8 py-10">
      <div className="w-full max-w-lg">
        <div className="flex items-center gap-3 mb-8">
          <span className="font-mono text-xs bg-ink text-page px-2 py-1 tracking-widest2">§ ADMIN</span>
          <span className="font-mono uppercase text-xs tracking-widest2 text-ink">Editor</span>
        </div>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="display text-5xl md:text-6xl leading-[0.9] text-ink mb-3"
        >
          Sign in.
        </motion.h1>
        <p className="serif-italic text-lg text-ink/85 mb-10">
          The Scrappy Marketer editor — private ground.
        </p>

        <motion.form
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.15 }}
          onSubmit={onSubmit}
          className="box-line p-6 md:p-8 flex flex-col gap-5"
          data-testid="admin-login-form"
        >
          <div>
            <label className="font-mono uppercase text-[10px] tracking-widest2 text-ink/70 block mb-1.5" htmlFor="admin-password">
              Password
            </label>
            <input
              id="admin-password"
              type="password"
              autoFocus
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Type your password"
              className="input-mono"
              data-testid="admin-password"
            />
          </div>

          {error && (
            <p className="font-mono uppercase text-xs tracking-widest2 text-clay" role="alert" data-testid="admin-login-error">
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={loading || !password}
            className="inline-flex items-center justify-between bg-ink text-page px-6 py-4 font-mono uppercase tracking-widest text-xs border border-ink hover:bg-lime hover:text-ink transition-colors duration-300 disabled:opacity-60 disabled:cursor-not-allowed"
            data-testid="admin-login-submit"
          >
            <span>{loading ? 'Signing in…' : 'Sign in'}</span>
            <span aria-hidden>→</span>
          </button>
        </motion.form>
      </div>
    </main>
  );
};
